import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createRootReducer  from '../reducers/reducer.root';
import rootSaga from '../saga/sagas';

export const history = createBrowserHistory();
const middleware = routerMiddleware(history);

const sagaMiddleware = createSagaMiddleware();

export const configStore = () => {
  const store = createStore(createRootReducer(history), applyMiddleware(middleware, sagaMiddleware));
  
  // Run Saga
  sagaMiddleware.run(rootSaga);  
  return store;
};







// WEBPACK FOOTER //
// ./src/store/config.tsx